import store from "../state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.currentUser != null) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/auth/register.vue"),
    meta: {
      title: "Inscription",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.currentUser != null) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/landing",
    name: "landing",
    component: () => import("../views/landing/index.vue"),
    meta: {
      title: "Amina - Logiciel de gestion commerciale",
      authRequired: false,
    },
  },
  {
    path: "/register/step2/:user",
    name: "register2",
    component: () => import("../views/auth/step2.vue"),
    meta: {
      title: "Inscription",
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.currentUser != null) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout")
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    meta: {
      title: "Non Autorisé",
      authRequired: false,
    },
    component: () => import("../views/auth/500.vue"),
  },

  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      key: 'dashboard'
    },
    component: () => import("../views/dashboard/index.vue"),
  },
  {
    path: "/no-subscription",
    name: "noSubscription",
    meta: {
      title: "Abonnement",
      authRequired: true,
      key: 'dashboard'
    },
    component: () => import("../views/auth/no_subscription.vue"),
  },
  {
    path: "/retours",
    name: "retours",
    meta: {
      title: "Retour de marchandise",
      authRequired: true,
      key: 'retour'
    },
    children: [
      {
        path: "",
        name: "retourForm",
        meta: {
          title: "Retour de marchandise",
          authRequired: true,
          key: 'retour'
        },
        component: () => import("../views/retours/retour.vue"),
      },
      {
        path: "invoice_return/:id",
        name: "invoiceReturn",
        meta: {
          title: "Retour de marchandise",
          authRequired: true,
          key: 'retour'
        },
        component: () => import("../views/retours/client_invoice_return.vue"),
      }
    ]
  },
  {
    path: "/rapports",
    name: "rapports",
    meta: {
      title: "Rapports",
      authRequired: true,
      key: 'rapports'

    },
    children: [
      {
        path: "rapport-ventes",
        name: "rapportVentes",
        meta: {
          title: "Rapport des ventes",
          authRequired: true,
          key: "rapport-ventes"
        },
        component: () => import("../views/rapports/rapport-vente.vue"),
      },
      {
        path: "rapport-achats",
        name: "rapportAchats",
        meta: {
          title: "Rapport des achats",
          authRequired: true,
          key: "rapport-achats"

        },
        component: () => import("../views/rapports/rapport-achats.vue"),
      },
      {
        path: "rapport-benefices",
        name: "rapportBenefice",
        meta: {
          title: "Rapport des bénéfices",
          authRequired: true,
          key: "rapport-benefices"

        },
        component: () => import("../views/rapports/rapport-benefice.vue"),
      },
      {
        path: "rapport-impayes",
        name: "rapportImpayes",
        meta: {
          title: "Rapport des impayés",
          authRequired: true,
          key: "rapport-impayes"

        },
        component: () => import("../views/rapports/rapport-impaye.vue"),
      },
      {
        path: "rapport-operations",
        name: "rapportOperations",
        meta: {
          title: "Rapport des opérations",
          authRequired: true,
          key: "rapport-operations"

        },
        component: () => import("../views/rapports/rapport-operations.vue"),
      },
    ]
  },
  {
    path: "/rapport-stock",
    name: "rapportStock",
    meta: {
      title: "Rapport de stock",
      authRequired: true,
      key: "rapport-stocks"

    },
    component: () => import("../views/rapport_stock.vue"),
  },
  {
    path: "/clients",
    name: "clients",
    meta: {
      title: "Clients",
      authRequired: true,
      key: 'customer'
    },
    children:[
      {
        path: "",
        name: "clientListe",
        meta: {
          title: "Clients",
          authRequired: true,
          key: 'liste-client'
        },
        component: () => import("../views/clients/index.vue"),
      },
      {
        path: "create",
        name: "clientCreate",
        meta: {
          title: "Clients",
          authRequired: true,
          key: 'create-client'

        },
        component: () => import("../views/clients/create.vue"),
      },
      {
        path: ":id/edit",
        name: "clientEdit",
        meta: {
          title: "Clients",
          authRequired: true,
          key: 'edit-client'

        },
        component: () => import("../views/clients/edit.vue"),
      },
    ]
  },
  {
    path: "/depenses",
    name: "depenses",
    meta: {
      title: "Dépenses",
      authRequired: true,
    },
    children:[
      {
        path: "",
        name: "depenseListe",
        meta: {
          title: "Dépenses",
          authRequired: true,
        },
        component: () => import("../views/depenses/index.vue"),
      },
      {
        path: "create",
        name: "depenseCreate",
        meta: {
          title: "Dépenses",
          authRequired: true,
        },
        component: () => import("../views/depenses/create.vue"),
      },
    ]
  },
  {
    path: "/paiement-fournisseurs",
    name: "paiementFournisseur",
    meta: {
      title: "Paiement fournisseur",
      authRequired: true,
      key: "paiement-fournisseurs"
    },
    children:[
      {
        path: "",
        name: "paiementFournisseurListe",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"liste-paiement_fournisseur"
        },
        component: () => import("../views/paiements/fournisseurs/index.vue"),
      },
      {
        path: "create",
        name: "paiementFournisseurCreate",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"create-paiement_fournisseur"

        },
        component: () => import("../views/paiements/fournisseurs/create.vue"),
      },
      {
        path: ":id/invoice",
        name: "paiementFournisseurInvoice",
        meta: {
          title: "Paiement Fournisseur",
          authRequired: true,
          key:"print-paiement_fournisseur"

        },
        component: () => import("../views/paiements/fournisseurs/receipt.vue"),
      },
    ]
  },
  {
    path: "/paiement-clients",
    name: "paiementClients",
    meta: {
      title: "Paiement client",
      authRequired: true,
      key: 'paiement-client'

    },
    children:[
      {
        path: "",
        name: "paiementClientListe",
        meta: {
          title: "Paiement client",
          authRequired: true,
          key: 'liste-paiement_client'
        },
        component: () => import("../views/paiements/clients/index.vue"),
      },
      {
        path: "create",
        name: "paiementClientCreate",
        meta: {
          title: "Paiement client",
          authRequired: true,
          key: 'create-paiement_client'

        },
        component: () => import("../views/paiements/clients/create.vue"),
      },
      {
        path: ":id/invoice",
        name: "paiementClientInvoice",
        meta: {
          title: "Paiement client",
          authRequired: true,
          key: 'print-paiement_client'
        },
        component: () => import("../views/paiements/clients/receipt.vue"),
      },
    ]
  },
  {
    path: "/fournisseurs",
    name: "fournisseurs",
    meta: {
      title: "Fournisseurs",
      authRequired: true,
      key: 'fournisseurs'

    },
    children:[
      {
        path: "",
        name: "fournisseurListe",
        meta: {
          title: "Fournisseurs",
          authRequired: true,
          key: 'liste-fournisseur'

        },
        component: () => import("../views/fournisseurs/index.vue"),
      },
      {
        path: "create",
        name: "fournisseurCreate",
        meta: {
          title: "Clients",
          authRequired: true,
          key: 'create-fournisseur'

        },
        component: () => import("../views/fournisseurs/create.vue"),
      },
      {
        path: ":id/edit",
        name: "fournisseurEdit",
        meta: {
          title: "Clients",
          authRequired: true,
          key: 'edit-fournisseur'

        },
        component: () => import("../views/fournisseurs/edit.vue"),
      },
    ]
  },
  {
    path: "/categorie-produits",
    name: "categorieProduits",
    meta: {
      title: "Catégorie de produits",
      authRequired: true,
      key: "categorie_produits"
    },
    children:[
      {
        path: "",
        name: "categorieProduitsListe",
        meta: {
          title: "Catégorie de produits",
          authRequired: true,
          key: "liste-categorie_produits"
        },
        component: () => import("../views/categorie-produits/index.vue"),
      },
      {
        path: "create",
        name: "categorieProduitCreate",
        meta: {
          title: "Catégorie de produits",
          authRequired: true,
          key: "create-categorie_produits"

        },
        component: () => import("../views/categorie-produits/create.vue"),
      },
      {
        path: ":id/edit",
        name: "CategorieProduitEdit",
        meta: {
          title: "Catégorie de produits",
          authRequired: true,
          key: "edit-categorie_produits"

        },
        component: () => import("../views/categorie-produits/edit.vue"),
      },
    ]
  },
  {
    path: "/unites",
    name: "unites",
    meta: {
      title: "Unité de mésure",
      authRequired: true,
      key: "unites"
    },
    children:[
      {
        path: "",
        name: "uniteListe",
        meta: {
          title: "Unité de mesure",
          authRequired: true,
          key: "liste-unites"
        },
        component: () => import("../views/unites/index.vue"),
      },
      {
        path: "create",
        name: "uniteCreate",
        meta: {
          title: "Unité de mesure",
          authRequired: true,
          key: "create-unites"

        },
        component: () => import("../views/unites/create.vue"),
      },
      {
        path: ":id/edit",
        name: "uniteEdit",
        meta: {
          title: "Clients",
          authRequired: true,
          key: "edit-unites"

        },
        component: () => import("../views/unites/edit.vue"),
      },
    ]
  },
  {
    path: "/produits",
    name: "produits",
    meta: {
      title: "Produits",
      authRequired: true,
      key: 'produits'

    },
    children:[
      {
        path: "",
        name: "produitListe",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'liste-produit'

        },
        component: () => import("../views/produits/index.vue"),
      },
      {
        path: "create",
        name: "produitCreate",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'create-produit'

        },
        component: () => import("../views/produits/create.vue"),
      },
      {
        path: ":id/edit",
        name: "produitEdit",
        meta: {
          title: "Produits",
          authRequired: true,
          key: 'edit-produit'

        },
        component: () => import("../views/produits/edit.vue"),
      },
    ]
  },
  {
    path: "/achats",
    name: "achats",
    meta: {
      title: "Achats",
      authRequired: true,
      key: "achats"
    },
    children:[
      {
        path: "",
        name: "achatListe",
        meta: {
          title: "Achats",
          authRequired: true,
          key: "liste-achat"
        },
        component: () => import("../views/achats/index.vue"),
      },
      {
        path: "create",
        name: "achatCreate",
        meta: {
          title: "Achats",
          authRequired: true,
          key: "create-achat"

        },
        component: () => import("../views/achats/create.vue"),
      },
      {
        path: ":id/edit",
        name: "achatEdit",
        meta: {
          title: "Achats",
          authRequired: true,
          key: "create-achat"

        },
        component: () => import("../views/achats/edit.vue"),
      },
    ]
  },
  {
    path: "/ventes",
    name: "ventes",
    meta: {
      title: "Ventes",
      authRequired: true,
      key: 'ventes'

    },
    children:[
      {
        path: "",
        name: "venteListe",
        meta: {
          title: "Vente",
          authRequired: true,
          key: 'liste-vente'

        },
        component: () => import("../views/ventes/index.vue"),
      },
      {
        path: "create",
        name: "venteCreate",
        meta: {
          title: "Vente",
          authRequired: true,
          key: 'create-vente'

        },
        component: () => import("../views/ventes/create.vue"),
      },
      {
        path: "gui_pos",
        name: "guiPosCreate",
        meta: {
          title: "Vente",
          authRequired: true,
          key: 'gui-vente'

        },
        component: () => import("../views/ventes/pos.vue"),
      },
      {
        path: ":id/edit",
        name: "venteFactureEdit",
        meta: {
          title: "Ventes",
          authRequired: true,
          key: 'edit-vente'

        },
        component: () => import("../views/ventes/edit.vue"),
      },
      {
        path: ":id/invoice",
        name: "venteInvoice",
        meta: {
          title: "Ventes",
          authRequired: true,
          key: 'vente-invoice'

        },
        component: () => import("../views/ventes/invoice.vue"),
      },
      {
        path: ":id/bon-commandes",
        name: "venteBonCommande",
        meta: {
          title: "Ventes",
          authRequired: true,
          key: 'vente-bon-commande'

        },
        component: () => import("../views/ventes/bon.vue"),
      },
    ]
  },
  {
    path: "/devis",
    name: "devis",
    meta: {
      title: "Devis",
      authRequired: true,
      key: 'devis'

    },
    children:[
      {
        path: "",
        name: "devisListe",
        meta: {
          title: "Devis",
          authRequired: true,
          key: 'liste-devis'

        },
        component: () => import("../views/devis/index.vue"),
      },
      {
        path: "create",
        name: "devisCreate",
        meta: {
          title: "Devis",
          authRequired: true,
          key: 'create-devis'

        },
        component: () => import("../views/devis/create.vue"),
      },
      {
        path: ":id/edit",
        name: "devisEdit",
        meta: {
          title: "Devis",
          authRequired: true,
          key: 'edit-vente'

        },
        component: () => import("../views/devis/edit.vue"),
      },
      {
        path: ":id/invoice",
        name: "devisInvoice",
        meta: {
          title: "Ventes",
          authRequired: true,
          key: 'vente-invoice'

        },
        component: () => import("../views/devis/invoice.vue"),
      },
      {
        path: ":id/bon-commandes",
        name: "venteBonCommande",
        meta: {
          title: "Ventes",
          authRequired: true,
          key: 'vente-bon-commande'

        },
        component: () => import("../views/ventes/bon.vue"),
      },
    ]
  },

  {
    path: "/configurations",
    name: "configurations",
    meta: {
      title: "Configurations",
      authRequired: true,
    },
    children:[
      {
        path: "boutiques",
        name: "configurationsBoutiques",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsBoutiqueListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/index.vue"),
          },
          {
            path: "create",
            name: "configurationsBoutiqueCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsBoutiqueEdit",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/boutiques/edit.vue"),
          },
        ]
      },
      {
        path: "roles",
        name: "configurationsRoles",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsRolesListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/index.vue"),
          },
          {
            path: "create",
            name: "configurationsRoleCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsRoleEdit",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/edit.vue"),
          },
        ]
      },
      {
        path: "users",
        name: "configurationUsers",
        meta: {
          title: "Configurations",
          authRequired: true,
        },
        children:[
          {
            path: "",
            name: "configurationsUserListe",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/users/index.vue"),
          },
          {
            path: "create",
            name: "configurationsUserCreate",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/users/create.vue"),
          },
          {
            path: ":id/edit",
            name: "configurationsUserEdit",
            meta: {
              title: "Configurations",
              authRequired: true,
            },
            component: () => import("../views/configurations/roles/edit.vue"),
          },
        ]
      },
    ]
  },
];